/*
 * Created by: cparaschiv
 * Date: 29.05.2013, 11:40
 */


var baseMapping = TS.domain.properties.DomainProperty.prototype.mapping;

/**
 * @class TS.domain.properties.SelectionListProperty
 * @extends TS.domain.properties.DomainProperty
 * @classdesc Abstraction of a list with a single selection. Usually associated with a drop-down list.
 */
var SelectionListProperty = TS.domain.properties.SelectionListProperty = new Class(
	/** @lends TS.domain.properties.SelectionListProperty# */
	{
		Extends: TS.domain.properties.DomainProperty,

		_resettingSelectedItem: false,

		autoSelect: false,

		events: [
			/**
			 * Fires before the selection changes. Event can be cancelled by calling <code>e.preventDefault()</code>.
			 * If the event is prevented the select operation is aborted.
			 * @event TS.domain.properties.SelectionListProperty#selectionChanging
			 * @example
			 * _hookProperties: function(){
         *   var me = this,
         *       phases;
         *
         *   me.parent();
         *
         *   phases = me.getDomainProperty('Phases2_Property');
         *   phases.on('selectionChanging', function(e){
         *      if (!me.allowSelect) {
         *          e.preventDefault();
         *      }
         *      console.log('Selection will change.');
         *   });
         * }
			 */
			'selectionChanging',
			/**
			 *
			 * @param {EventArgs} e
			 * @param {Object} e.record  The newly selected item
			 * @param {TS.domain.properties.SelectionListProperty} e.sender The selection list property
			 */
			'selectionChanged',
			'reset'
		],

		mapping: $.extend({}, baseMapping, {
			ignore: baseMapping.ignore.concat(['DisplayValue', 'ClientFilters']),
			copy: baseMapping.copy.concat(['ListMember', 'ValueMember', 'ListReferences', 'EmptyText', 'AllowEmptySelection', 'records', 'autoSelect']),
			suppress: baseMapping.suppress.concat(['DisplayMember', 'ListMember', 'ValueMember', 'ListReferences', 'EmptyText', 'AllowEmptySelection', 'records', 'autoSelect'])
		}),

		observables: {
			SelectedItem: null
		},


		//region Constructor

		initialize: function (domain, config) {
			var me = this;

			me.parent(domain, config);
			me.initKendoDataSource();
			//after all is set, create bindings
			config.ClientFilters && me.createClientFiltersBindings(config.ClientFilters);
		},

		//endregion


		//region Properties

		//region DisplayValue

		DisplayValue: function (value) {
			if (arguments.length === 0)
				return this.getDisplayValue();
			return this.setDisplayValue(value);
		},

		getDisplayValue: function () {
			var me = this;

			if (me.DisplayMember && ko.valueOf(me.DisplayMember)) {
				var dataSource = me[TS.Constants.ownerProp],
					displayMember = ko.valueOf(me.DisplayMember);
				if (ts.hasValue(dataSource) && ts.hasValue(displayMember)) {
					var result = ts.getPropertyValue(dataSource, displayMember);
					if (TS.isObject(result) && 'Value' in result) {
						return result.Value();
					}
					return ts.getPropertyValue(dataSource, displayMember);
				}
				return null;
			} else {
				return me._displayValue;
			}
		},

		setDisplayValue: function (value) {
			var me = this;

			if (me.DisplayMember && ko.valueOf(me.DisplayMember)) {
				var dataSource = me[TS.Constants.ownerProp],
					displayMember = ko.valueOf(me.DisplayMember);
				if (ts.hasValue(dataSource) && ts.hasValue(displayMember)) {
					var displayValue = ts.getPropertyValue(dataSource, displayMember);
					if (TS.isObject(result) && 'Value' in displayValue) {
						displayValue.Value(value);
						return;
					}
					ts.setPropertyValue(dataSource, displayMember, value);
				}
			} else {
				me._displayValue = value;
			}
		},

		//endregion

		//endregion

		//region Methods

		hookDomain: function () {
			var me = this,
				subscriptions = me._subscriptions;
			me.parent();

			subscriptions.push(me.SelectedItem.subscribe(function (value) {
				if (me._resettingSelectedItem || me._oldSelectedItem == value)
					return;

				me.onSelectedItemChanged(value, true, me._oldSelectedItem);
			}, me));
		},

		unhookDomain: function () {
			var me = this;
			me.parent();
			me._disposeSubscriptions();
		},

		//endregion

		_getData: function () {
			var me = this;
			return me.parent();
		},

		_setData: function (data) {
			var me = this,
				dataSource = me.ListSource;

			// dispose subscriptions, will be recreated in _watch* methods
			me.unhookDomain();

			me.parent(data);

			var selectedItem = me.findSelectedItem();
			me._oldSelectedItem = selectedItem;
			TS.Util.setObservableWithoutRaisingSubscriptions(me.SelectedItem, selectedItem);
			me._selectedItemId = me.getItemIdentifier(selectedItem);

			me.hookDomain();
		}
	});

SelectionListProperty.mixin = function (target) {
	target.implement({
		//region UI

		initKendoDataSource: function () {
			var me = this;

			if (!('ListSource' in me)) {

				me.transport = new TS.LazyTransport(me.getKendoTransportConfig());

				var dataSource = new TS.LazyDataSource(
					{
						transport: me.transport,
						serverFiltering: true,

						change: function () {
							var selectedItem = me.findSelectedItem();
							me._oldSelectedItem = me._oldSelectedItem || selectedItem;
							me._selectedItemId = me.getItemIdentifier(selectedItem);
						}
					}),
					getFilter = function (property) {
						var parts = property.split('.'),
							filterName = parts[0],
							filters = me.transport.filters;
						return $.grep(filters, function (f) {
							return f.field === filterName;
						});
					},
					filters = {
						getPropertyValue: function (property) {
							var filter = getFilter(property);
							if (filter.length > 0) {
								return f[0].value;
							}
							return null;
						},

						setPropertyValue: function (property, value) {
							var reset = false,
								domain = me.Domain(),
								owner = me._getOwner(),
								parts = property.split('.'),
								filterName = parts[0],
								filters = me.transport.filters,
								filter = $.grep(filters, function (f) {
									return f.field === filterName;
								});
							if (filter.length > 0) {
								if (filter[0].value != value) {
									filter[0].value = value;
									reset = true;
								}
							} else {
								filters.push({field: filterName, operator: "eq", value: value});
								reset = true;
							}
							reset && me.clientFiltersBinding !== true && domain.propertiesBinding !== true && (!owner || owner.propertiesBinding !== true) && me.reset();
						}
					};

				Object.defineProperty(dataSource, 'Filters', {
					get: function () {
						return filters;
					}
				});
				Object.defineProperty(me, 'ListSource', {
					get: function () {
						return dataSource;
					}
				});
			}
		},

		getKendoComboConfig: function () {
			var me = this,
				dataSource = me.ListSource;

			return {
				dataValueField: me.ValueMember,
				dataTextField: me.ListMember,
				value: me.Value(),
				text: me.DisplayValue(),
				autoBind: false,
				dataSource: dataSource
			};
		},

		getKendoTransportConfig: function () {
			var me = this,
				domain = me.Domain();

			return {
				read: {
					url: TS.unwrap(domain.rootUrl) + '/' + TS.Constants.Url.GetComboData
				},
				filters: [],
				allowEmptySelection: me.AllowEmptySelection,
				emptyText: me.EmptyText,
				valueProperty: me.ValueMember,
				textProperty: me.ListMember,
				dataSourceName: me.propertyPath || TS.unwrap(me.Name),
				modelUID: TS.unwrap(domain.modelUID),
				subdomain: domain.subdomainPath,
				type: 'lazy'
			};
		},

		//endregion

		//region Filters

		setFilter: function (fieldName, value) {
			this.ListSource.Filters.setPropertyValue(fieldName, value);
		},

		clearFilter: function () {
			this.transport.filters = [];
		},

		//endregion

		createClientFiltersBindings: function (config) {
			var me = this,
				domain = me.Domain();
			me.ClientFilters = me.ClientFilters || {};
			$.each(config, function (filter, source) {
				var filterExpression = 'ListSource.Filters.' + filter + '.Value',
					globalValue = TS.Util.getProperty(window, source, true);
				try {
					me.clientFiltersBinding = true;
					if (globalValue) {
						ts.setPropertyValue(me, filterExpression, globalValue);
					} else {
						function valueChanged(newValue) {
							ts.setPropertyValue(me, filterExpression, newValue);
						}
						var binding = me.ClientFilters[source] = me.ClientFilters[source] || {},
							accessor = binding.accessor = binding.accessor || domain.watch(source, me, valueChanged);
						valueChanged(accessor.value());
					}
				} finally {
					me.clientFiltersBinding = false;
				}
			});
		},

		getItemIdentifier: function (item) {
			if (item)
				return item.UID || item.uid;
			return -1;
		},

		findSelectedItem: function (value) {
			var me = this,
				dataSource = me.ListSource;
			if (dataSource && dataSource.data) {

			    // Value can be a function, an observable or a aprimitive value
			    var evaluatedValue = typeof (this.Value) == "function" ? this.Value() : this.Value;

			    return TS.Util.find(dataSource.data(), me.ValueMember, evaluatedValue);
			}
			return null;
		},

		onSelectedItemChanging: function () {
			var me = this;
			return me.promiseEvent('selectionChanging');
		},

		onSelectedItemChanged: function (newItem, raiseEvent, oldItem) {
			var me = this,
				doRaise = false,
				newSelectedItemId = me.getItemIdentifier(newItem);

			if (me._selectedItemId != newSelectedItemId) {
				var selectedItem = me.SelectedItem() || {},
					domain = me.Domain();
				$.each(me.ListReferences || {}, function (index, reference) {
					ts.setPropertyValue(domain, reference.target, selectedItem[reference.source] || null);
				});
				me._selectedItemId = newSelectedItemId;
				me._oldSelectedItem = newItem;
				doRaise = true;
			}

			if (raiseEvent !== false && doRaise)
				return me.fireEvent('selectionChanged', {prevRecord: oldItem, record: newItem, sender: me});
		},


		/**
		 * Clears the cache for the data source of the list.
		 * Reopening the associated drop-down fetches the data from server again.
		 */
		invalidateList: function () {
			var me = this,
				transport = me.transport,
				ds = me.ListSource;

			transport && transport.invalidateCache();
			me.fireEvent("beforeClearCache");
			ds && ds.data([]);
			me.fireEvent("afterClearCache");
		},

		onAutoSelectDone: function () {
			var me = this;
			if (me.autoSelectHandlers) {
				me.autoSelectHandlers.forEach(function (handler) {
					handler();
				});
				delete me.autoSelectHandlers;
			}
		},

		onAutoSelect: function (handler) {
			var me = this;
			if (me.autoSelecting) {
				me.autoSelectHandlers = me.autoSelectHandlers || [];
				me.autoSelectHandlers.push(handler);
				return;
			}
			handler();
		},

		doReset: function () {
			var me = this,
				domain = me.Domain(),
				silent = domain.avoidResettingValueFromFilters === true,
				ds = me.ListSource;

			!silent && (me.Value(null));
			!silent && (me.DisplayValue(null));
			try {
				silent && (me._resettingSelectedItem == true);
				me.SelectedItem(null);
			} finally {
				silent && (me._resettingSelectedItem == true);
			}
			ds && ds.data([]);
			me.isResetting = false;
			me.fireEvent('reset');
		},

		reset: function () {
			var me = this,
				dataSource = me.ListSource,
				currentValue = me.Value();

			me.isResetting = true;
			if (me.autoSelect === true && currentValue !== null && typeof currentValue !== 'undefined') {
				me.autoSelecting = true;
				me.invalidateList();
				dataSource.fetch(function () {
					try{
						var selectedItem = TS.Util.find(dataSource.data(), me.ValueMember, currentValue);
						if (selectedItem) {
							me.SelectedItem(selectedItem);
							return;
						}
						me.doReset();
					} finally {
						me.isResetting = false;
						me.autoSelecting = false;
						me.onAutoSelectDone();
					}
				});
				return;
			}
			me.doReset();
		},
	});
};

SelectionListProperty.mixin(SelectionListProperty);

TS.ObjectFactory.map('SelectionListProperty', TS.domain.properties.SelectionListProperty);